import * as types from "./types";
import axios from "../../../common/config/axios";

export const getMemberProgress = () => (dispatch) => {
  axios
    .get("daily_check_in/member_progress")
    .then((res) => {
      dispatch({
        type: types.DAILY_CHECK_IN_MEMBER_PROGRESS,
        payload: res,
      });
    })
    .catch((error) => {
      console.error(error);
    });
};

export const checkIn = (data) => (dispatch) => {
  axios
    .post("daily_check_in/check_in", data)
    .then((res) => {
      dispatch({
        type: types.DAILY_CHECK_IN_CHECK_IN,
        payload: res,
      });
    })
    .catch((error) => {
      console.error(error);
    });
};

export const clearProgress = () => (dispatch) => {
  axios
    .post("daily_check_in/clear_progress", {})
    .then((res) => {
      dispatch({
        type: types.DAILY_CHECK_IN_CLEAR_PROGRESS,
        payload: res,
      });
    })
    .catch((error) => {
      console.error(error);
    });
};

